import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const watchlistFiltersApi = createApi({
  reducerPath: "watchlistFiltersApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (build) => ({
    getSectors: build.query<{ sectors: string[] }, void>({
      query: () => ({
        url: "watchlist/sectors",
        method: "GET",
      }),
    }),
    getIndustries: build.query<{ industries: string[] }, void>({
      query: () => ({
        url: "watchlist/industries",
        method: "GET",
      }),
    }),
    getCategories: build.query<{ categories: string[] }, void>({
      query: () => ({
        url: "watchlist/categories",
        method: "GET",
      }),
    }),
  }),
});

export const { useGetSectorsQuery, useGetIndustriesQuery, useGetCategoriesQuery } =
  watchlistFiltersApi;
